/** Templates de parecer e checklist de análise por tipologia (LP/LI/LO). */

export const PARECER_TEMPLATES = {
  LP: `PARECER TÉCNICO — LICENÇA PRÉVIA (LP)

1. Identificação do processo e do empreendimento
2. Tipologia e enquadramento (CONAMA 237/1997 e normas locais)
3. Localização, zoneamento e interferência em APP / UC
4. Estudos apresentados (EIA/RIMA, RAS, RCA — o que couber)
5. Análise da viabilidade ambiental
6. Condicionantes propostas para a LP
7. Conclusão: deferido / com exigências / indeferido

Fundamentação:`,
  LI: `PARECER TÉCNICO — LICENÇA DE INSTALAÇÃO (LI)

1. Conformidade com a LP e com o projeto aprovado
2. Projetos executivos e programas ambientais
3. Controle de efluentes, emissões, ruído e resíduos de obra
4. Cronograma de implantação e medidas mitigadoras
5. Condicionantes da LI
6. Conclusão: deferido / com exigências / indeferido

Fundamentação:`,
  LO: `PARECER TÉCNICO — LICENÇA DE OPERAÇÃO (LO)

1. Conformidade da implantação com a LI
2. Relatórios de monitoramento e cumprimento de condicionantes
3. Operação: efluentes, emissões, resíduos e plano de emergência
4. Prazos de validade e renovação (CONAMA 237)
5. Condicionantes da LO
6. Conclusão: deferido / com exigências / indeferido

Fundamentação:`,
};

export const ANALISE_CHECKLIST = {
  LP: [
    'Enquadramento CONAMA 237 / tipologia do empreendimento',
    'Competência do órgão (municipal / estadual / federal)',
    'Estudo ambiental compatível com o porte (EIA, RAS ou RCA)',
    'Localização e interferência em APP, UC ou zona de amortecimento',
    'Uso e ocupação do solo compatível com o zoneamento',
    'Participação / audiência pública quando exigida',
  ],
  LI: [
    'LP válida e condicionantes da LP cumpridas ou programadas',
    'Projeto de engenharia coerente com o licenciado',
    'Sistemas de controle ambiental de obra especificados',
    'Plano de gerenciamento de resíduos da construção',
    'Cronograma de implantação e pontos de fiscalização',
    'Programas ambientais (PBA) protocolados',
  ],
  LO: [
    'LI cumprida e obras conforme o projeto',
    'Relatórios de monitoramento apresentados',
    'Condicionantes da LI com evidência de cumprimento',
    'Operação com controle de efluentes/emissões em funcionamento',
    'Plano de emergência e responsável técnico indicados',
    'Prazo de validade e regra de renovação definidos',
  ],
};

export function inferLicenseKind(nome) {
  const text = String(nome || '').toUpperCase();
  if (/\bLO\b|OPERA/.test(text)) return 'LO';
  if (/\bLI\b|INSTALA/.test(text)) return 'LI';
  if (/\bLP\b|PR[ÉE]VIA/.test(text)) return 'LP';
  return 'LP';
}

export function serializeAnaliseChecklist(kind, checks) {
  const items = ANALISE_CHECKLIST[kind] || ANALISE_CHECKLIST.LP;
  return items.map((label) => `${checks[label] ? '[x]' : '[ ]'} ${label}`).join('\n');
}
